module.exports = "https://web-assets-production.autolist.com/_next/static/images/body-type-sprite-lg-fc0da1d1b768d3612312dfd558885ad5.png";